<template>
  <cx-showcase-section :name="name" :link="link">
    <div class="cxu-display-flex-column">
      <!-- singleselect -->
      <div class="cxu-d-flex cxu-gap-40">
        <cx-list
          class="cxu-flex"
          :items="subtitleListItems"
          @update:selectedItems="onSelectionChanged"
          v-model:selectedItems="l1selectedIds"
          :disabledItems="[listItems[0]]"
          header="Single Select">
        </cx-list>

        <cx-dynamic-list
          class="cxu-flex"
          :items="listItems"
          @update:selectedItems="onSelectionChanged"
          v-model:selectedItems="l2SelectedIds"
          :disabledItems="[listItems[1]]"
          header="Single Select Virtualized List"
          :itemSize="37">
        </cx-dynamic-list>
      </div>


      <!-- multiselect -->
      <div class="cxu-d-flex cxu-gap-40 cxu-mt-50">
        <cx-list
          class="cxu-flex"
          multiselect
          :items="subtitleListItems"
          @update:selectedItems="onSelectionChanged"
          v-model:selectedItems="l3SelectedIds"
          header="Multi Select">
        </cx-list>

        <!-- warning header -->
        <cx-dynamic-list
          class="cxu-flex"
          multiselect
          :items="listItems"
          @update:selectedItems="onSelectionChanged"
          v-model:selectedItems="l4SelectedIds"
          :disabledItems="[listItems[1]]"
          header="Multi Select With Warning"
          :itemSize="37">
          <template #default="{ item, selected, disabled}">
            <cx-list-item
              :item="item"
              :selected="selected"
              :disabled="disabled"
              :warning="true"/>
          </template>
          <template #header-append="{}">
            <cx-warning warning="Large Reference Models" tooltip="Large Reference Models"/>
          </template>
        </cx-dynamic-list>
      </div>

      <!-- empty -->
      <div class="cxu-d-flex cxu-gap-40 cxu-mt-50">
        <cx-list
          class="cxu-flex  empty-list"
          header="Empty">
        </cx-list>

        <cx-dynamic-list
          class="cxu-flex  empty-list"
          header="Empty">
        </cx-dynamic-list>
      </div>

      <!-- loading -->
      <div class="cxu-d-flex cxu-gap-40 cxu-mt-50">
        <cx-list
          class="cxu-flex  empty-list"
          header="Results"
          :loading="true">
        </cx-list>

        <cx-dynamic-list
          class="cxu-flex  empty-list"
          header="Results"
          :items="listItems"
          @update:selectedItems="onSelectionChanged"
          v-model:selectedItems="l1selectedIds"
          :disabledItems="[listItems[2], listItems[1]]"
          :loading="true">
        </cx-dynamic-list>
      </div>
    </div>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '../CxShowcaseSection';
import CxList from '@/components/list/CxList';
import CxListItem from '@/components/list/CxListItem';
import CxDynamicList from '@/components/list/CxDynamicList';
import CxWarning from '@/components/CxWarning';

export default {
  name: 'CxListShowcase',
  components: {
    CxList,
    CxListItem,
    CxDynamicList,
    CxWarning,
    CxShowcaseSection
  },
  data() {
    return {
      name: 'CxList',
      link: 'https://miro.com/app/board/o9J_lDPoVY8=/?moveToWidget=3074457359875630434&cot=14',
      listItems: [
        { id: 1, title: 'Item 1' },
        { id: 2, title: 'Item 2' },
        { id: 3, title: 'Item 3' },
      ],
      subtitleListItems: [
        { id: 1, title: 'Item 1', subtitle: 'subtitle 1' },
        { id: 2, title: 'Item 2', subtitle: 'subtitle 2' },
        { id: 3, title: 'Item 3', subtitle: 'subtitle 3' },
      ],
      l1selectedIds: [{ id: 2 }],
      l2SelectedIds: [{ id: 1 }],
      l3SelectedIds: [{ id: 2 }],
      l4SelectedIds: [{ id: 1 }],
    };
  },
  methods: {
    onSelectionChanged(item) {
      // eslint-disable-next-line no-console
      console.log('list selection changed:', item);
    }
  }
};

</script>

<style lang="less">
@import '../../../common';

.empty-list {
  height: 200px;
  border: 1px solid black;
}

</style>
